export const getApplicationRootPath = (pathname, defaultPath = null) => {
  if (!pathname) return defaultPath;

  const pathArr = pathname.split('/');
  return pathArr.length > 1 ? `/${pathArr[1]}` : defaultPath;
};
